import { FORMIK } from "./formik.reducer";

const selectFormById = (state, id) => {
    return id ? state[FORMIK][id] : null;
};

export { selectFormById };
